export default {
    'type-message': '訊息類',
    'type-market': '市場類',
    'type-work': '實作類',
    'type-observe': '觀察類'
};
